/**
 * Get the editor canvas iframe document if it exists
 */
export const getEditorCanvasDocument = (): Document | null => {
	const iframe = document.querySelector(
		'iframe[name="editor-canvas"]',
	) as HTMLIFrameElement;
	return iframe?.contentDocument ?? null;
};
